import { httpRequest } from "../../http";

export interface CreateDefinitionPayload {
  name: string;
  config: any[];
  organization?: { id: number; name: string };
  is_active?: boolean;
  population_segment_id?: number;
  population_segment_name?: string;
  // The primary data spec this one's files hang off (MPN-1564).
  depends_on_id?: number | null;
  hold_on_missing_members?: boolean;
}

export class CommandCreateDefinition {
  async run(payload: CreateDefinitionPayload) {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/definitions/`;
    const response = await httpRequest<any>(url, {
      method: "POST",
      body: payload,
    });
    return response;
  }
}
